import { useEffect } from 'react';
import { useQuery } from 'v3/hooks/useQuery';

import SuccessTemplate from 'templates/Success';
import ManCelebrating from 'assets/images/man-celebrating.png';

import * as S from './styles';

const PaymentSuccess = () => {
  const query = useQuery();
  const name = query.get('name') ?? '';

  useEffect(() => {
    if (!name) {
      window.location.href = 'https://contractflow.savings.club/deals/';
    }
  }, [name]);

  return (
    <SuccessTemplate firstName={name} img={ManCelebrating}>
      <S.Container>
        <S.Text>
          <strong>Now you are a club member!</strong>
        </S.Text>
        <S.Text>
          Everything went well with your payment, access your app and follow the
          situation of your group
        </S.Text>
        <S.Button
          type="button"
          onClick={() => {
            window.location.href = `?closeWebview=true&name=${name}`;
          }}
        >
          <S.CheckAppText>{'Check your app >'}</S.CheckAppText>
        </S.Button>
      </S.Container>
    </SuccessTemplate>
  );
};

export default PaymentSuccess;
